import React from 'react'
import { useOutlet } from 'react-router-dom'
import { Stack } from '@mui/material'

import { AcquiringPaymentsTable } from './acquiring-payments-table.tsx'
import { AcquiringPaymentsFilters } from './acquiring-payments-filters.tsx'
import { AqcActionButtons } from './acquiring-action-buttons.tsx'

export const AcquiringPaymentsPage = (): React.ReactElement => {
  const outlet = useOutlet()
  if (outlet) return outlet

  return (
    <Stack gap={3}>
      <AqcActionButtons />
      <AcquiringPaymentsFilters />
      <AcquiringPaymentsTable />
    </Stack>
  )
}
